import { TokenService } from "../../services/TokenService";

const headers = TokenService.getHeaders();

export const CommonAPIService = {

    callApiUsingUrl: async function (url) {
        let response;
        try {
            response = await fetch(url, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }
        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)

            return {error: response}
        }
    },
    callApiUsingUrlReturnBlob: async function (url) {
        let response;
        try {
            response = await fetch(url, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.blob();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },

    getConsolidationLevels: async function () {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Common/GetConsolidationLevels', {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return {error: response}
        }
    },
    getCurrencies: async function () {
        let response;

        try {
            const response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Common/GetCurrencies', {
                headers: headers
            });
            return await response.json();
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return {error: response}
        }
    },
    getMappingTypes: async function () {
        let response;

        try {
            const response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Common/GetMappingTypes', {
                headers: headers
            });
            return await response.json();
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return {error: response}
        }
    },
    getScenarioTypes: async function () {
        let response;

        try {
            const response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Common/GetScenarioType', {
                headers: headers
            });
            return await response.json();
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return {error: response}
        }
    },
    getMappingTypesByNodeId: async function (id) {
        let response;

        try {
            const response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Common/GetMappingTypesByNodeId/' + id, {
                headers: headers
            });
            return await response.json();
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)

            return { error: response };
        }
    },
};